import * as _ from 'lodash';
import React, { FormEvent } from 'react'
import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Radio } from 'react-bootstrap'
import { IRecipientProfilePostTransplantData } from '@nkr/models/index'
import { IValidation } from './validation';
import MaskedInput from 'react-maskedinput';

interface IProps {
    data: IRecipientProfilePostTransplantData,
    validation: IValidation,
    onChange: (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => void,
}

const GraftStatus = (props: IProps) => {
    if (props == null) {
        return <></>
    }

    return (
        <Form horizontal>
            <FormGroup validationState={props.validation.graftSurvival == false ? 'error' : null}>
                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                    Graft Survival:
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <div style={{ minHeight: 34 }}>
                        <Radio id='graftSurvivalYes' name='graftSurvival' inline value={1} checked={props.data.graftSurvival == true} onChange={props.onChange}>Yes</Radio>
                        <Radio id='graftSurvivalNo' name='graftSurvival' inline value={0} checked={props.data.graftSurvival == false} onChange={props.onChange}>No</Radio>
                        <Radio id='graftSurvivalUnknown' name='graftSurvival' inline value={-1} checked={props.data.graftSurvival == null} onChange={props.onChange}>Unknown</Radio>
                    </div>
                </Col>
            </FormGroup>

            {props.data.graftSurvival == false && (
                <>
                    <FormGroup validationState={props.validation.graftFailureDate == false ? 'error' : null}>
                        <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                            Graft Failure Date:
                        </Col>
                        <Col xs={12} sm={12} lg={6}>
                            <MaskedInput
                                name='graftFailureDate'
                                className='form-control'
                                mask='11/11/1111'
                                placeholder='mm/dd/yyyy'
                                value={props.data.graftFailureDate}
                                onChange={props.onChange}
                            />
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={props.validation.graftFailureReason == false ? 'error' : null}>
                        <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                            Graft Failure Reason:
                        </Col>
                        <Col xs={12} sm={12} lg={6}>
                            <FormControl
                                componentClass='select'
                                name='graftFailureReason'
                                value={props.data.graftFailureReason}
                                onChange={props.onChange}
                            >
                                <option key={'graftFailureReason-selected'} value={''}>- Select -</option>
                                <option key={'graftFailureReason-selected-death'} value={'Death'}>Death</option>
                                <option key={'graftFailureReason-selected-rejection'} value={'Rejection'}>Rejection</option>
                                <option key={'graftFailureReason-selected-thrombosis'} value={'Thrombosis/Surgical Complication'}>Thrombosis/Surgical Complication</option>
                                <option key={'graftFailureReason-selected-malignancy'} value={'Malignancy'}>Malignancy</option>
                                <option key={'graftFailureReason-selected-cardiovascular'} value={'Cardiovascular Disease'}>Cardiovascular Disease</option>
                                <option key={'graftFailureReason-selected-infection'} value={'Infection/Illness other than Recurrent disease'}>Infection/Illness other than Recurrent disease</option>
                                <option key={'graftFailureReason-selected-recurrent'} value={'Recurrent Disease'}>Recurrent Disease</option>
                                <option key={'graftFailureReason-selected-other'} value={'Other'}>Other</option>
                            </FormControl>
                        </Col>
                    </FormGroup>


                    {props.data.graftFailureReason == 'Other' && (
                        <FormGroup validationState={props.validation.graftFailureReasonOther ? null : "error"}>
                            <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                                Other Details:
                            </Col>
                            <Col xs={12} sm={12} lg={6}>
                                <FormControl
                                    componentClass='textarea'
                                    style={{ resize: 'none', height: 75 }}
                                    maxLength={255}
                                    name="graftFailureReasonOther"
                                    value={props.data.graftFailureReasonOther}
                                    onChange={props.onChange}
                                />
                                <HelpBlock style={{ marginBottom: 0 }}>255 characters max</HelpBlock>
                            </Col>
                        </FormGroup>
                    )}

                    {props.data.graftFailureReason == 'Rejection' && (
                        <FormGroup validationState={props.validation.rejectionDueToNonCompliance ? null : "error"}>
                            <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                                Rejection due to Non-Compliance:
                            </Col>
                            <Col xs={12} sm={12} lg={6}>
                                <div style={{ minHeight: 34 }}>
                                    <Radio id='rejectionDueToNonCompliance' name='rejectionDueToNonCompliance' inline value={1} checked={props.data.rejectionDueToNonCompliance == 1} onChange={props.onChange}>Yes</Radio>
                                    <Radio id='rejectionDueToNonCompliance' name='rejectionDueToNonCompliance' inline value={0} checked={props.data.rejectionDueToNonCompliance == 0} onChange={props.onChange}>No</Radio>
                                </div>
                            </Col>
                        </FormGroup>
                    )}
                </>
            )}

            <FormGroup validationState={props.validation.hadDelayedGraftFunction == false ? 'error' : null}>
                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                    Delayed Graft Function:
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <div style={{ minHeight: 34 }}>
                        <Radio id='hadDelayedGraftFunctionYes' name='hadDelayedGraftFunction' inline value={1} checked={props.data.hadDelayedGraftFunction == true} onChange={props.onChange}>Yes</Radio>
                        <Radio id='hadDelayedGraftFunctionNo' name='hadDelayedGraftFunction' inline value={0} checked={props.data.hadDelayedGraftFunction == false} onChange={props.onChange}>No</Radio>
                        <Radio id='hadDelayedGraftFunctionUnknown' name='hadDelayedGraftFunction' inline value={-1} checked={props.data.hadDelayedGraftFunction == null} onChange={props.onChange}>Unknown</Radio>
                    </div>
                </Col>

            </FormGroup>

            <FormGroup validationState={props.validation.primaryNonFunction == false ? 'error' : null}>
                <Col xs={12} sm={12} lg={6} componentClass={ControlLabel}>
                    Primary Non-Function:
                </Col>
                <Col xs={12} sm={12} lg={6}>
                    <div style={{ minHeight: 34 }}>
                        <Radio id='primaryNonFunctionYes' name='primaryNonFunction' inline value={1} checked={props.data.primaryNonFunction == true} onChange={props.onChange}>Yes</Radio>
                        <Radio id='primaryNonFunctionNo' name='primaryNonFunction' inline value={0} checked={props.data.primaryNonFunction == false} onChange={props.onChange}>No</Radio>
                        <Radio id='primaryNonFunctionUnknown' name='primaryNonFunction' inline value={-1} checked={props.data.primaryNonFunction == null} onChange={props.onChange}>Unknown</Radio>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    )
}

export default GraftStatus;